import { AxonDeviceModels } from '../models/device-model.enum';

/**
 * SVG template for Axon Outpost and Lightpost device icons
 * Uses CSS custom property --status-color for dynamic coloring based on device status
 * ViewBox is expanded to 48x48 to prevent clipping during rotation
 */
export const OUTPOST_LIGHTPOST_SVG_TEMPLATE = `
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="-8 -8 48 48" width="40" height="40">
  <g transform="rotate(0 16 16)">
    <path id="outer_border" data-name="outer border" style="fill: var(--status-color, #50ea5f)" d="M30.88,7.91c-.7-.46-1.59-.54-2.36-.21l-1.08.68c-.31-2.19-2.16-3.88-4.44-3.88H4.5C2.01,4.5,0,6.51,0,9v14c0,2.49,2.01,4.5,4.5,4.5h18.5c2.27,0,4.13-1.69,4.44-3.88l1.08.68c.77.33,1.66.25,2.36-.21.7-.46,1.12-1.25,1.12-2.09v-12c0-.84-.42-1.62-1.12-2.09Z"/>
    <path id="body_main" data-name="body main" style="fill: var(--status-color, #50ea5f)" d="M23.83,6.54c-.14-.03-.28-.04-.42-.04H4.09c-1.15,0-2.09.95-2.09,2.11v14.78c0,1.17.93,2.11,2.09,2.11h19.32c1.15,0,2.09-.95,2.09-2.11v-14.78c0-1.02-.72-1.87-1.67-2.07Z"/>
    <path id="black_outline" data-name="black outline" style="fill: #000" d="M30.19,8.96c-.35-.23-.79-.27-1.18-.11t0,0l-2.76,1.4v-1.25c0-1.79-1.46-3.25-3.25-3.25H4.5c-1.79,0-3.25,1.46-3.25,3.25v14c0,1.79,1.46,3.25,3.25,3.25h18.5c1.79,0,3.25-1.46,3.25-3.25v-1.25l2.76,1.4c.16.07.33.1.49.1.24,0,.48-.07.69-.21.35-.23.56-.62.56-1.04v-12c0-.42-.21-.81-.56-1.04ZM25,23c0,1.1-.9,2-2,2H4.5c-1.1,0-2-.9-2-2v-14c0-1.1.9-2,2-2h18.5c1.1,0,2,.9,2,2v14ZM29.5,22l-3.25-1.61v-8.79l3.25-1.61v12Z"/>
    <path id="body_end" data-name="body end" style="fill: #000" d="M7,23v-14c0-1.1.9-2,2-2h-4.5c-1.1,0-2,.9-2,2v14c0,1.1.89,2,2,2h4.5c-1.1,0-2-.9-2-2Z"/>
    <path id="delta_outline" data-name="delta outline" d="M7.67,15l-4.12-3c-.25-.17-.56-.25-.87-.25-.22,0-.44.04-.64.13-.49.21-.8.64-.8,1.12v6c0,.47.31.91.8,1.12.2.09.43.13.64.13.31,0,.61-.08.87-.25l4.12-3c.36-.24.58-.61.58-1s-.21-.76-.58-1Z"/>
    <polygon id="delta_fill" data-name="delta fill" style="fill: #efff08" points="2.5 13 7 16 2.5 19 2.5 13"/>
    <polygon id="lens" style="fill: var(--status-color, #50ea5f)" points="29.5 22 29.5 10 26.25 11.61 26.25 20.39 29.5 22"/>
  </g>
  <g id="glyph" transform="translate(10, 10)">
    <!-- GLYPH_CONTENT -->
  </g>
</svg>
`;

/**
 * Outpost glyph SVG path (shared between DSA and Presence device models)
 */
const OUTPOST_GLYPH = `
  <path d="M2.39941 0.502441C2.53747 0.502441 2.64939 0.614394 2.64941 0.752441V2.80225L3.61035 3.32568L3.8125 1.93359C3.83579 1.7734 3.99206 1.6675 4.14941 1.70557L10.5762 3.09912C10.7538 3.1422 10.8404 3.3436 10.75 3.50244L9.05322 6.16064C9.00938 6.22931 8.93491 6.27233 8.85352 6.27588L6.93701 6.35938L3.89893 5.62451L3.89746 5.62109L2.64941 5.3291V11.2476C2.64939 11.3856 2.53747 11.4976 2.39941 11.4976H1.25C1.11205 11.4974 1.00003 11.3855 1 11.2476V0.752441C1.00003 0.614467 1.11205 0.502561 1.25 0.502441H2.39941Z" fill="black"/>
  <path d="M6.90186 7.09863H7.72949C7.78552 7.09877 7.82155 7.15815 7.7959 7.20801L6.53516 9.65869C6.41101 9.87674 6.15465 9.98341 5.9126 9.91748L3.55713 9.38184C3.4176 9.34364 3.33157 9.20331 3.36035 9.06152L3.35205 6.25342L6.90186 7.09863Z" fill="black"/>
`;

/**
 * Device-specific glyph SVG paths
 * Each glyph represents the specific icon for a device type (Outpost, Lightpost, etc.)
 * Supports both DSA (AxonDeviceModels) and Presence (PresenceDeviceModels) keys
 */
export const DEVICE_GLYPHS: { [key: string]: string } = {
  // DSA device model key
  [AxonDeviceModels.AxonOutpost]: OUTPOST_GLYPH,
  
  // Presence device model keys (same glyph)
  'axon:outpost': OUTPOST_GLYPH,
  'outpost': OUTPOST_GLYPH,
};

